import { clsx } from "clsx";

import { alertInfoPalettes } from "./class-names";
import { AlertProps } from "./types";
import { Button } from "../button";
import { Icon } from "../icon";
import { Link as LinkComponent } from "../link";

export const AlertInfo = ({
  palette = "default",
  heading,
  content,
  actions,
  onClose,
}: AlertProps) => (
  <div
    className={clsx(
      alertInfoPalettes[palette].background,
      "flex gap-[1.2rem] p-[1.2rem] rounded relative overflow-hidden min-h-fit",
      !heading && !actions?.length && "items-center",
    )}
  >
    <span className="w-[2.4rem] h-[2.4rem] inline-flex justify-center items-center">
      <Icon
        className={alertInfoPalettes[palette].iconColor}
        name={alertInfoPalettes[palette].iconName}
      />
    </span>
    <div className="flex flex-1 flex-col justify-between">
      {heading && (
        <div className="flex gap-[0.8rem] items-center mb-[0.8rem]">
          <h2
            className={clsx(
              alertInfoPalettes[palette].iconColor,
              "flex-1 text-paragraph font-semibold",
            )}
          >
            {heading}
          </h2>
        </div>
      )}
      <div>
        <div className="text-ui" data-testid="alert-info-content">
          {content}
        </div>
        {!!actions?.length && (
          <div className="flex gap-[1.6rem] mt-[1.6rem]">
            {actions.map((action, index) => (
              <LinkComponent
                key={action.text}
                variant={action.variant || "default"}
                text={action.text}
                onClick={action.onClick}
                dataTestId={`alert-info-action-${index}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
    {onClose && (
      <div className="flex">
        <Button
          variant="secondarySubtle"
          leftIcon="regularXmark"
          onClick={onClose}
          dataTestId="alert-info-close"
          size="small"
        />
      </div>
    )}
  </div>
);
